import type { Schema } from "../../..";
import type { Parser } from "../parser";

export class TemplatesNameParser implements Parser {
	parse(schema: Record<string, Schema.Template>) {
		const names = Object.keys(schema).map((name) => `"${name}"`);

		return names.length ? `export type Templates = ${names.join("|")}` : "";
	}
}
